import { isSuperAdmin } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'subscriptions',
    path: '/subscriptions',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "subscriptions" */ '@/views/Subscription/Subscriptions.vue')),
    beforeEnter: isSuperAdmin,
  },
  {
    name: 'subscription-edit',
    path: '/subscriptions/:id',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "subscription-edit" */ '@/views/Subscription/Mutate.vue')),
    beforeEnter: isSuperAdmin,
  },
]
